<template>
    <el-dialog :visible.sync="visible" :close-on-click-modal="false" :title="title" width="600px">
        <div class="pay" v-loading="loading" element-loading-text="加载中...">
            <!-- 商品详情区域 -->
            <div class="goods-detail" v-if="goodsInfo">
                <h3 class="goods-title">{{ goodsInfo.title }}</h3>
                <div class="goods-price">
                    <span class="current-price">¥{{ (goodsInfo.price * goodsInfo.discount / 100).toFixed(2) }}</span>
                    <span class="original-price">原价: ¥{{ goodsInfo.price }}</span>
                    <span class="discount-tag">{{ goodsInfo.discount / 100 }}折</span>
                </div>
                <div class="goods-features">
                    <div class="feature-item">
                        <span class="label">会话时间:</span>
                        <span class="value">{{ goodsInfo.validity_minutes }}分钟</span>
                    </div>
                    <div class="feature-item">
                        <span class="label">实到流量:</span>
                        <span class="value">{{ goodsInfo.internet_traffic == 0 ? '不限量' : goodsInfo.internet_traffic + 'GB' }}</span>
                    </div>
                    <div class="feature-item">
                        <span class="label">IP数量:</span>
                        <span class="value">{{ goodsInfo.limitation_ip == 0 ? '不限量' : goodsInfo.limitation_ip + '个' }}<span v-if="goodsInfo.gift > 0" class="gift-text"> + 赠送{{ goodsInfo.gift }}个</span></span>
                    </div>
                    <div class="feature-item">
                        <span class="label">套餐有效期:</span>
                        <span class="value">{{ goodsInfo.duration_days == 0 ? '永久' : goodsInfo.duration_days + '天' }}</span>
                    </div>
                </div>
            </div>
            
            <!-- 订单信息区域 -->
            <div class="order-info">
                <h4>订单信息</h4>
                <dl class="u-flex u-row-between">
                    <dt>订单号:</dt>
                    <dd>{{ orderData.order_sn }}</dd>
                </dl>
                <dl class="u-flex u-row-between" v-if="orderData.ip_type">
                    <dt>IP类型:</dt>
                    <dd v-if="orderData.ip_type == 0">国内</dd>
                    <dd v-else-if="orderData.ip_type == 1">国外</dd>
                    <dd v-else>未知</dd>
                </dl>
                <dl class="u-flex u-row-between">
                    <dt>IP提取数量:</dt>
                    <dd>{{ orderData.ip_num == 0 ? '不限' : orderData.ip_num + '个' }}</dd>
                </dl>
                <dl class="u-flex u-row-between" v-if="orderData.goods_validity_day > 0">
                    <dt>套餐有效期:</dt>
                    <dd>{{ orderData.goods_validity_day }}天</dd>
                </dl>
                <dl class="u-flex u-row-between" v-if="orderData.goods_validity_day > 0 && orderData.paytype == 1">
                    <dt>套餐到期时间:</dt>
                    <dd>{{ orderData.goods_validity_tiem }}</dd>
                </dl>
                <dl class="u-flex u-row-between">
                    <dt>实际流量:</dt>
                    <dd>{{ orderData.internet_traffic == 0 ? '不限' : orderData.internet_traffic + 'GB' }}</dd>
                </dl>
                <dl class="u-flex u-row-between">
                    <dt>支付金额:</dt>
                    <dd>
                        <span class="new-price">¥{{ orderData.saleamount }}</span>
                        <span class="ml20 old-price">原价:¥{{ orderData.amount }}</span>
                    </dd>
                </dl>
            </div>
            <dl class="u-flex u-row-between">
                <dt>支付方式:</dt>
                <dd>
                    <el-radio-group v-model="paytype">
                        <el-radio label="balance">
                            <div class="u-flex">
                                <img class="ml10" src="../assets/images/balance.png" alt="">
                                <em class="ml10">余额</em>
                            </div>
                        </el-radio>
                        <el-radio label="alipay">
                            <div class="u-flex">
                                <img class="ml10" src="../assets/images/gmdl_zhifubao.png" alt="">
                                <em class="ml10">支付宝</em>
                            </div>
                        </el-radio>
                        <el-radio label="wechat">
                            <div class="u-flex">
                                <img class="ml10" src="../assets/images/gmdl_weixin.png" alt="">
                                <em class="ml10">微信</em>
                            </div>
                        </el-radio>

                    </el-radio-group>
                </dd>
            </dl>
            <div class="instruction">
                <p><span>购买须知:</span>(1)如遇支付异常，请更换支付方式或联系专属销售</p>
                <p><span></span>(2)所有类型产品需实名认证后且在境外环境下使用</p>

            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false" size="mini">取消</el-button>
            <el-button type="primary"  size="mini" @click="onConfirm" :loading="confirmLoading">立即支付</el-button>
        </span>
    </el-dialog>

</template>

<script>
import { order } from '../api'
export default {
    props: {
        title: '',
    },
    data() {
        return {
            orderData: {},
            goodsInfo: null, // 存储商品详情
            paytype: 'balance',
            loading: false,
            confirmLoading: false,
            visible: false,
        }
    },
    methods: {
        onOpen(order_sn, goodsInfo = null) {
            this.visible = true
            this.loading = true
            this.orderData = {}
            this.goodsInfo = goodsInfo // 保存商品信息
            
            order.getOrderDetail({
                order_sn: order_sn
            }).then(res => {
                this.orderData = res.data
            }).finally(() => {
                this.loading = false
            })
        },
        onConfirm() {
            if (!this.orderData.order_sn) {
                this.$message.warning('订单信息不完整')
                return
            }
            
            // 验证支付方式
            if (!this.paytype) {
                this.$message.warning('请选择支付方式')
                return
            }
            
            this.confirmLoading = true
            
            // 构建支付参数，包含商品ID和支付方式
            const payParams = {
                order_sn: this.orderData.order_sn,
                paytype: this.paytype
            }
            
            // 如果有商品信息，也传递商品ID
            if (this.goodsInfo && this.goodsInfo.id) {
                payParams.goods_id = this.goodsInfo.id
            }
            
            order.orderPay(payParams).then(res => {
                // 处理支付结果
                if (this.paytype === 'balance') {
                    this.$message.success('余额支付成功')
                    this.visible = false
                    // 可以触发父组件刷新或其他操作
                    this.$emit('pay-success', {
                        order_sn: this.orderData.order_sn,
                        goods_id: this.goodsInfo ? this.goodsInfo.id : null,
                        paytype: this.paytype
                    })
                } else if (this.paytype === 'wechat') {
                    // 微信支付 - 显示二维码弹窗
                    this.showWechatPayDialog(res.data)
                } else if (this.paytype === 'alipay') {
                    // 支付宝支付 - 跳转到支付页面
                    this.redirectToAlipay(res.data)
                } else {
                    // 其他第三方支付，打开支付页面
                    const newWindow = window.open();
                    newWindow.document.write(res.data.html);
                    newWindow.document.close();
                }
            }).catch(err => {
                this.$message.error('支付失败：' + (err.message || '未知错误'))
            }).finally(() => {
                this.confirmLoading = false
            })
        },
        
        // 显示微信支付弹窗
        showWechatPayDialog(payData) {
            // 获取二维码数据，支持多种字段名和base64格式
            let qrCodeData = payData.qr_code || payData.qrcode || payData.qrCode || ''
            
            // 如果是base64格式，需要添加data:image前缀
            if (qrCodeData && !qrCodeData.startsWith('data:image') && !qrCodeData.startsWith('http')) {
                // 假设返回的是纯base64数据，添加图片前缀
                qrCodeData = `data:image/png;base64,${qrCodeData}`
            }
            
            // 创建微信支付弹窗
            this.$confirm(
                `<div style="text-align: center;">
                    <h3>微信扫码支付</h3>
                    <div style="margin: 20px 0;">
                        <img src="${qrCodeData}" alt="微信支付二维码" style="max-width: 200px; height: auto; border: 1px solid #eee; border-radius: 4px;">
                    </div>
                    <p>请使用微信扫描二维码完成支付</p>
                    <p style="color: #ff6b35; font-weight: bold;">支付金额：¥${this.orderData.saleamount}</p>
                    <p style="color: #999; font-size: 12px; margin-top: 10px;">二维码加载失败时请刷新页面重试</p>
                </div>`,
                '微信支付',
                {
                    confirmButtonText: '支付完成',
                    cancelButtonText: '取消',
                    dangerouslyUseHTMLString: true,
                    customClass: 'wechat-pay-dialog',
                    showCancelButton: true,
                    center: true
                }
            ).then(() => {
                this.$message.success('支付完成！')
                this.visible = false
                // 触发支付成功事件
                this.$emit('pay-success', {
                    order_sn: this.orderData.order_sn,
                    goods_id: this.goodsInfo ? this.goodsInfo.id : null,
                    paytype: this.paytype
                })
            }).catch(() => {
                this.$message.info('支付已取消')
            })
        },
        
        // 跳转到支付宝支付
        redirectToAlipay(payData) {
            if (payData.redirect_url) {
                // 如果有重定向URL，直接跳转
                window.location.href = payData.redirect_url
            } else if (payData.html) {
                // 如果有HTML内容，打开新窗口
                const newWindow = window.open()
                newWindow.document.write(payData.html)
                newWindow.document.close()
            } else {
                this.$message.error('支付宝支付链接获取失败')
            }
        }
    }
}
</script>

<style>
.pay {
    padding: 20px;
}

.pay dl {
    padding: 10px 0;
    font-size: 14px;
}

.pay .el-radio-group {
    display: flex;
    align-items: center;
}

.pay dl .el-radio {
    padding: 10px 24px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #d2d2d2;
}

.new-price {
    color: #ff2537;
    font-size: 16px;
    font-weight: bold;
}

.old-price {
    color: #999;
    text-decoration: line-through;
}

.instruction {
    padding: 10px 0;
}

.instruction p {
    line-height: 30px;
    color: #ff2537;
    font-size: 12px;
}

.instruction span {
    width: 66px;
    display: inline-block;
}

/* 加载状态样式 */
.pay ::v-deep .el-loading-mask {
    background-color: rgba(255, 255, 255, 0.8);
}

.pay ::v-deep .el-loading-spinner {
    margin-top: -20px;
}

.pay ::v-deep .el-loading-text {
    color: #409EFF;
    font-size: 14px;
}

/* 对话框样式优化 */
.pay ::v-deep .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #ebeef5;
}

.pay ::v-deep .el-dialog__body {
    padding: 20px;
}

.pay ::v-deep .el-dialog__footer {
    padding: 10px 20px 20px;
    text-align: right;
    border-top: 1px solid #ebeef5;
}

/* 商品详情样式 */
.goods-detail {
    margin-bottom: 30px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
    border-left: 4px solid #2682ff;
}

.goods-title {
    margin: 0 0 15px 0;
    color: #2682ff;
    font-size: 18px;
    font-weight: 600;
}

.goods-price {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.current-price {
    color: #ff7319;
    font-size: 20px;
    font-weight: bold;
}

.original-price {
    color: #999;
    font-size: 14px;
    text-decoration: line-through;
}

.discount-tag {
    padding: 2px 8px;
    color: #fff;
    font-size: 12px;
    background: #ff6b35;
    border-radius: 4px;
}

.goods-features {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.feature-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
}

.feature-item .label {
    color: #666;
    font-size: 14px;
}

.feature-item .value {
    color: #333;
    font-size: 14px;
    font-weight: 500;
}

.gift-text {
    color: #ff6b35;
    font-weight: 600;
    font-size: 12px;
    background: linear-gradient(45deg, #ff6b35, #f7931e);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

/* 订单信息样式 */
.order-info {
    margin-bottom: 20px;
    padding: 20px;
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 8px;
}

.order-info h4 {
    margin: 0 0 15px 0;
    color: #333;
    font-size: 16px;
    font-weight: 600;
    border-bottom: 1px solid #e9ecef;
    padding-bottom: 10px;
}

/* 微信支付弹窗样式 */
::v-deep .wechat-pay-dialog {
    width: 400px;
}

::v-deep .wechat-pay-dialog .el-message-box__content {
    padding: 30px 20px;
}

::v-deep .wechat-pay-dialog .el-message-box__header {
    background: #07c160;
    color: white;
    padding: 15px 20px;
}

::v-deep .wechat-pay-dialog .el-message-box__title {
    color: white;
    font-weight: 600;
}

::v-deep .wechat-pay-dialog .el-message-box__headerbtn .el-message-box__close {
    color: white;
}

::v-deep .wechat-pay-dialog .el-message-box__btns {
    padding: 15px 20px;
    text-align: center;
}

::v-deep .wechat-pay-dialog .el-button--primary {
    background: #07c160;
    border-color: #07c160;
}

::v-deep .wechat-pay-dialog .el-button--primary:hover {
    background: #06ad56;
    border-color: #06ad56;
}
</style>